export default {
  title: 'ҚӨУ. Оқу жүктемесін жоспарлау және есепке алу',
  name: 'Оқу жүктемесін жоспарлау және есепке алу',

  menu: {
    admin: 'Әкімші панелі',
    reports: 'Есептер',
    main: 'Басты бет',
    config: 'Баптау',
    logout: 'Шығу'
  },

  confirmation: {
    title: 'Назар аударыңыз!',
    message: 'Әрекетті растаңыз.',
    ok: 'Иә',
    cancel: 'Жоқ'
  },
  notification: {
    close: 'Жабу'
  }
}
